import { Injectable } from '@angular/core';
import { HttpGeneralService, StockParms, InPatientParms, StockModuleSettingsParms } from '../../shared/shared';

import { PatientReservation, RegPatEpisode, RegPatVisit, TherapeuticCards } from '../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';

import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service'

import { ApprovalRequest } from "../../approvals"
import { CONFIG } from '../../shared/config';
import { ItemUnits, stockTransBarCodes } from '../../stock-transaction/stock-transaction-interface/gen-stock-transaction.service';
import { RxDetails, RxGen } from '../../rx/rx-gen';

const patientsUrl = CONFIG.baseUrls.patients;
const templateUrl = CONFIG.baseUrls.genTemplate;

let stockTransUrl = CONFIG.baseUrls.StockTrans;
let rxUrl = CONFIG.baseUrls.rx;
let inpatientlistUrl = CONFIG.baseUrls.inpatientlist;
let StockPermissionUrl = CONFIG.baseUrls.StockPermission;
let NicutpnUrl = CONFIG.baseUrls.Nicu_Tpn;
let labTestUrl = CONFIG.baseUrls.labTest;
//===============================================================Gouhar==============================/////


export interface StockTransMaster {

  tranSerial: number;
  storeCode: number;
  transType: number;
  totalCost: number;
  totalSale: number;
  transDate: Date;
  supplierCode: number;
  billNo: number;
  handNumber?: number;
  transStatus?: number;
  causeOfReflux?: number;
  notes?: string;
  beneficiaryStore?: number;
  parentTransId?: number;
  depCode?: number;
  exchangeCode?: number;
  updateStatus?: number;
  customerSerial?: number;
  visitSerial?: number;
  patSerial?: number;
  docSerial?: number;
  episodeSerial?: number;
  contractSerial?: number;
  exchangeServiceAccess?: number;
  deleveryEmpCode?: number;
  serviceSerial?: number;
  examinationSupCode?: number;
  permissionCode?: number;
  placeCode?: number;
  patSharingPercentFromCardFlag?: number;
  rxMasterSerial?: number;
  activeMaterialFlag?: number;
  suspensionSerial?: number;
  approvalSerial?: number;
}
//===============================================Gouhar==============================/////

export interface StockTransDetail { 
  serial: number
  tranSerial: number;
  itemCode: number;
  count: number;
  unitCode: number;
  unitCost: number;
  unitSale: number;
  totalCost: number;
  totalSale: number;
  cashCharge: number;
  expirationDate: Date;
  smallUnitCode: number;
  countBySmallUnit: number;
  additionTransCode: number;
  ivItemsMixSerial: number; 
  taxNature: number;
  discount: number;
  discountType: number;
  additionalDiscount: number;
  additionalDiscountType: number;
  tax: number;
  taxType: number;
  gift: any;
  havePatches: number;
  rxFlage?: number;
  rxStoreItemSerial?: number;
  balanceAfterTrans?: number;
  examinationSupplyCode?: number;
  smalUnitCost?: number;
  smalUnitSale?: number;
  detailOldSerial?: number;
  patchCodeOld?: string;
  genricOrBrand?: string;
  composite?: number;
  permissionCode?: number;
  rxMasterSerial?: number;
  rxDetailSerial?: number;
  noDays?: number;
  noRxDose?: number;
  userStartDate?: Date;
  uiEntryIndex?: number;
  updateBarcode?: number;
  barcode?: string;
  patSharingPercentFromCardFlag?: number;
  compatibility: string;
  ellyNumber?: string;
  regPatOperationToolSerial?: number;
  oldItemCode?: number;
  groupType?: number;
  groupId?: number;
}
//============================================================Gouhar==============================/////

export interface StockTransBalance {

  serial: number
  storeCode: number;
  itemCode: number;
  itemCost: number;
  balance: number;
  smallUnitCode: number;
  smallUnitCost: number;
  smallUnitSale: number;
  supplierCode: number;
  smallUnitTotalSale: number;
  patchCode: string;
  PatchCodeStr: string;
  detailSerial: number;
  expirationDate: Date;
  stockTraParentPatch: number;
  patchUnitCode: number;
  taken: number;
  dataStatus: number;
  detailOldSerial?: number;
  unitCode?: number;
  donationDate: Date;
  qrCode: string;





}
export interface directAddObj {
  serial?: number;
  serialOfDirectAdd?: string;
  handNumber?: string;
  jsonMaster?: string;
  jsonDetails?: string;
  jsonMasteritemUnits?: string;
  dataStatus?: number;
  examinaionCode?: number;
  poOrderCode?: number;
  supplierCode?: number;
  stocktype?: number;
}

export interface TransferStoreTrans {

  regPatVisit?: RegPatVisit;
  therapeuticCards?: TherapeuticCards;
  regPatEpisode?: RegPatEpisode;
  approvals?: ApprovalRequest[];

  stockTransMaster?: StockTransMaster[],
  stockTransDetail?: StockTransDetail[],
  stockTransBalance?: StockTransBalance[],
  stockTransBarCodes?: stockTransBarCodes[];

}
//==================================general service in stock=============================/////

@Injectable()
export class GenStockTransService {
  constructor(
    private httpGeneralService: HttpGeneralService) { }

  getInpatientData(moduleParms: InPatientParms) {
    return this.httpGeneralService.search(moduleParms, inpatientlistUrl);
  }

  RxInpatientMaster(moduleParms: InPatientParms) {
    return this.httpGeneralService.post(moduleParms, `${inpatientlistUrl}/RxInpatientMaster`);
  }
  RxInpatientMasterLoadDetail(moduleParms: InPatientParms) {
    return this.httpGeneralService.post(moduleParms, `${inpatientlistUrl}/RxInpatientMasterLoadDetail`);
  }

  RxPeriodDoseQty(rxMasterSerial: number, noDays: any) {
    return this.httpGeneralService.getWith(`${inpatientlistUrl}/rxGetDosesQty/${rxMasterSerial}/${noDays}`);
  }

  getUnitsByItemId(itemCode: number) {
    return this.httpGeneralService.get(itemCode, stockTransUrl);
  }

  getItemsByTransCodes(TransCodes: number) {

    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsByTransCodes/${TransCodes}`);
  }
  getNicutpn(Nicutpn: any) {
    return this.httpGeneralService.add(Nicutpn, `${NicutpnUrl}/getNicu_TpnLoad`);
  }

  getItemsPatches(itemCode: number, storeCode: number, transferQuan: number, cfPriceCode: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsPstches/${itemCode}/${storeCode}/${isNaN(transferQuan) ? 1 : transferQuan}/${cfPriceCode}`)
  }

  getItems(itemCodes: string) {

    return this.httpGeneralService.getWith(`${stockTransUrl}/${itemCodes}`)
  }
  checkForItemInBalance(itemCodes: any, storeCode: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsPstches/${itemCodes}/${storeCode}`)
  }

  transfereTtemFromStore(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add<TransferStoreTrans>(transferStoreTrans, stockTransUrl);
  }


  itemsLoad(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/itemsLoad`);
    //data[0]
  }
  permitRefluxTrans(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/PermitRefluxTrans`);
    //data[0]
  }

  itemsPrice(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${stockTransUrl}/itemsPrice`);
    //data[0]
  }
  GetInventoryTransToConfirm(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetInventoryTransToConfirm`);
  }
  getInventoryTransactionINHOS(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllInventoryTransactions`);
  }
  getDeliveryTransList(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/SearchDeliveryTrans`);
  }

  GetAllItemsInStore(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllItemsInInventory`);

  }
  deleteStockTrans_Inventory(_Sto: StockTransMaster) {
    return this.httpGeneralService.add<StockTransMaster>(_Sto, `${stockTransUrl}/DeleteStockTrans`);
  }

  //////+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  GetAllItemsByMasterSerial(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllItemsByMasterSerial`);
  }
  //////+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //------------------------------------------------functions print -------------------
  OpenBalncePrint(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/OpenBalncePrint`);
  }


  loadRx(RxData: RxGen) {
    return this.httpGeneralService.search(RxData, `${rxUrl}/LoadRx`);
  }
  updateRx(RxDetails: RxDetails[]) {
    return this.httpGeneralService.add(RxDetails, `${rxUrl}/UpdateRx`);
  }
  updateTradeNameRx(RxDetails: RxDetails[]) {
    return this.httpGeneralService.add(RxDetails, `${rxUrl}/UpdateTradeNameRx`);
  }


  getItemsByServiceID(ServiceId: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/ItemServiceSerach/${ServiceId}`);
  }

  AssignTyaRToTRansaction(_Sto: StockTransMaster) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/AssignTyaRToTRansaction`);
  }

  getProcessRequirmentItems(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/getProcessRequirmentPrintInfo`);
  }

  getMedicationalter(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/StrGetItemsAlterAndMatrial`);
  }


  genTemplateItemsSearch(genTemplateItems: any) {
    return this.httpGeneralService.search(genTemplateItems, `${templateUrl}/Items/Store`);
  }

  // get patient with code
  getPatient(id: string) {
    return this.httpGeneralService.getWith(`${patientsUrl}/${id}`);
  }

  getStockPermission(permissionSerial?: number, permissionType?: number, storeType?: number) {
    return this.httpGeneralService.getWith(`${StockPermissionUrl}/StockPermissonsLoad/${permissionSerial}/${permissionType}/${storeType}`)
  }

  getItemBalanceCard(strunits: string, _qty: number) {
    //abdo;
    let FullDesc = '';
    const allUnitsDescAr = strunits;
    let balanceMain = { qty: _qty };


    if (allUnitsDescAr) {
      let splittedArr = [];
      let itemunitsWithFactor: ItemUnits[] = [];
      let MaxFactor: number = 1;
      let itemRowUnitsArr = allUnitsDescAr.split('-');
      itemRowUnitsArr.forEach(x => {
        splittedArr.push(x.replace('(', '').replace(')', ''));
      })
      splittedArr.forEach(i => {
        let itemUnit = <ItemUnits>{};
        //let itemUnit: ItemUnits  = <ItemUnits>{};

        itemUnit.factor = +(i.split(':')[0]);
        itemUnit.unit = (i.split(':')[1]);
        if (MaxFactor < itemUnit.factor) {
          MaxFactor = itemUnit.factor;
        }
        itemunitsWithFactor.push(itemUnit);
      })
      itemunitsWithFactor.forEach(ele => {
        ele.factor = MaxFactor / ele.factor;
      })



      itemunitsWithFactor.sort((a, b) => (a.factor > b.factor) ? -1 : (a.factor === b.factor) ? ((a.factor > b.factor) ? -1 : 1) : 1)
      itemunitsWithFactor.forEach(element => {
        FullDesc = FullDesc + this.getDesc(element, balanceMain)
      });



    }
    return FullDesc;
  }

  getDesc(itemunit: ItemUnits, qty: any) {
    let remaining = 0;
    let Desc = '';
    if (qty.qty > 0) {
      let factor2Integer = Math.floor(qty.qty / itemunit.factor);
      if (factor2Integer > 0) {
        Desc = factor2Integer.toString() + ' ' + itemunit.unit;
      }
      qty.qty = qty.qty - (factor2Integer * itemunit.factor);
    }
    return Desc;
  }
  getStockModuleSettings(parms: StockModuleSettingsParms) {
    return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }

  addStockTransactionSuspension(directAddObj: directAddObj) {
    return this.httpGeneralService.add(directAddObj, `${stockTransUrl}/directAddObj`);
  }
  searchRXs(searchObj: any) {
    return this.httpGeneralService.add(searchObj, `${rxUrl}/searchSp`);
  }

  cshDepositPermissionRequestBySerial(Serial: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/CshDepositPermissionRequestBySerial/${Serial}`);
  }
  uploadImageBase64(obj: any) {
    return this.httpGeneralService.post(obj, `${labTestUrl}/UploadImage`);
  }

}
